import { render, staticRenderFns } from "./providerRtpTab.vue?vue&type=template&id=9c0dbf44&lang=pug"
import script from "./providerRtpTab.vue?vue&type=script&lang=js"
export * from "./providerRtpTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports